import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import swal from 'sweetalert'
import { Animated } from 'react-animated-css';
import MobileToggle from '../mobileToggles/mobileToggles';
import { connect } from 'react-redux';
import { callApi, setEmployeeDetails } from '../../store/reducers/commonFunction'
import common from '../../store/reducers/commons'
import errorMessages from '../../store/reducers/errorMessages'
import Leftbar from './leftbar/Leftbar';
import SidebarAnnouncement from '../sidebarAnnouncement/SidebarAnnouncement';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { withRouter } from 'react-router';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css';
import QRCode from 'qrcode.react';
import PermissionModal from '../../component/PermissonModal/PermissionModal';
import helper from '../../services/helper';
import appConstant from '../../constant/appConstant';

class Contacts extends Component {

    /**
    |--------------------------------------------------
    | constructor
    |--------------------------------------------------
    */

    constructor(props) {
        super(props);
        this.state = {
            viewEmployee: true,
            editEmployee: false,
            employee: undefined,
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            photo_url: '',
            file: '',
            designation: '',
            name: '',
            employeDelete: '',
            rawPhone: '',
            dial_code: '',
            errors: {
                name: '', first_name: '', last_name: '', email: '', designation: ''
            },

            crop: {
                unit: '%',
                width: 100,
                height: 50,
                aspect: 16 / 4,
            },
            isLoading: false,
            isAPICall: false,
            isVisibleAddContact: false,
            isPermissionModalVisible: false,
            qrCodeLink: ''
        }
    }

    /**
    |--------------------------------------------------
    | componentDidMount
    |--------------------------------------------------
    */

    async componentDidMount() {
    }

    /**
    |--------------------------------------------------
    | viewEmployeeBtn
    |--------------------------------------------------
    */

    viewEmployeeBtn = () => {
        this.setState({ viewEmployee: true })
        this.setState({ editEmployee: false })
    }

    /**
    |--------------------------------------------------
    | editEmployeeBtn
    |--------------------------------------------------
    */

    editEmployeeBtn = () => {
        const { employee } = this.state;
        this.setState({
            isVisibleAddContact: true,
            editEmployee: true,
            first_name: employee.first_name,
            last_name: employee.last_name,
            email: employee.email,
            phone: employee.phone,
            rawPhone: employee.phone,
            designation: employee.designation,
            errors: {
                message: ''
            },
            photo_url: employee.image,
            dialcode: employee.dialcode,
            imagePreview: undefined,
            croppedImageUrl: undefined,
            src: undefined
        })
    }

    /**
    |--------------------------------------------------
    | setParentStatus
    |--------------------------------------------------
    */

    setParentStatus = async (id) => {
        console.log('employee-->', JSON.stringify(id));
        // let	{ first_name,last_name, email, phone, file,id } = id;
        let qrCodeLink = `BEGIN:VCARD\r\nVERSION:2.1\r\N:${id.first_name + " " + id.last_name}\r\nORG:${id.company_name || ''}\r\nTITLE:${id.designation}\r\nTEL;TYPE=cell:${id.dialcode + id.phone}\r\nEMAIL;PREF;INTERNET:${id.email}\r\nEND:VCARD`
        this.setState({
            employee: id,
            // first_name: id.first_name, 
            // last_name: id.last_name,
            // email: id.email, 
            // photo_url: id.image, 
            // phone: id.phone, 
            user_id: id.user_id,
            // designation: id.designation, 
            company_id: id.company_id,
            // dialcode: id.dialcode,
            qrCodeLink: qrCodeLink
        })
    }

    /**
    |--------------------------------------------------
    | editEmployeProfile
    |--------------------------------------------------
    */

    /**
    |--------------------------------------------------
    | editEmployeProfile
    |--------------------------------------------------
    */

    editEmployeProfile = async (e) => {
        e.preventDefault();
        var { Imgblob, first_name, last_name, dialcode, rawPhone, file, email, designation, company_id, user_id } = this.state;

        if (this.validateForm()) {
            const formData = new FormData();
            this.setState({
                isAPICall: true
            })
            console.log("rawPhone-->", rawPhone)
            console.log("dialcode-->", dialcode)
            if (file) {
                formData.append('image', Imgblob)
            }
            // formData.append('image',file)
            formData.append('first_name', first_name)
            formData.append('last_name', last_name)
            formData.append('email', email)
            formData.append('designation', designation)
            formData.append('company_id', company_id)
            formData.append('user_id', user_id)
            formData.append('phone', rawPhone)
            formData.append('dialcode', dialcode)
            const response = await this.props.callApi('/updateEmployee', formData, 'post', null, true);
            if (response.data.status === true) {
                this.setState({
                    userName: response.data,
                    photo_url: response.data.image,
                    isVisibleAddContact: false,
                    isAPICall: false
                })

                common.showSuccessMessage(response.data.message)
                this.leftBarRef.getEmployeeDetails(this.state.employee.user_id, false);
            } else {
                this.setState({
                    isAPICall: false
                })
            }
        }
    }

    /**
    |--------------------------------------------------
    | AddNewEmploye
    |--------------------------------------------------
    */

    AddNewEmploye = async (event) => {
        event && event.preventDefault();
        var { Imgblob, first_name, last_name, email, rawPhone, dial_code, file, designation } = this.state;
        let company_id = this.props.userData.company_id ? this.props.userData.company_id : '';

        if (this.validateForm()) {
            const formData = new FormData()
            this.setState({
                isAPICall: true
            })
            if (file) {
                formData.append('image', Imgblob)
            }
            formData.append('first_name', first_name)
            formData.append('last_name', last_name)
            formData.append('email', email)
            formData.append('designation', designation)
            formData.append('company_id', company_id)
            formData.append('phone', rawPhone)
            formData.append('dialcode', dial_code)

            const response = await this.props.callApi('/addSingleEmployee', formData, 'post', null, true);
            console.log('addSingleEmployee response-->', JSON.stringify(response))
            if (response.data.code === 200) {
                common.showSuccessMessage(response.data.message);
                this.setState({
                    isVisibleAddContact: false,
                    isAPICall: false
                })
                this.leftBarRef.getEmployeeDetails(undefined, false)
            } else {
                this.setState({
                    isAPICall: false
                })
            }
        }
    }

    /**
    |--------------------------------------------------
    | validateForm
    |--------------------------------------------------
    */

    validateForm() {
        let { first_name, last_name, phone, email, designation, errors, isFormValid } = this.state;
        if (!first_name.trim()) {
            errors.first_name = errorMessages.PROVIDE_FIRST_NAME;
            // } else if (!last_name.trim()) {
            //     errors.last_name = errorMessages.PROVIDE_LAST_NAME;
        } else if (!email.trim()) {
            errors.email = errorMessages.PROVIDE_EMAIL;
        } else if (helper.isValidEmail(email)) {
            errors.email = errorMessages.PROVIDE_VALID_EMAIL;
        } else if (!phone.trim()) {
            errors.phone = errorMessages.PROVIDE_MOBILE_NUMBER;
        } else if (helper.isValidPhoneNumber(phone)) {
            errors.phone = errorMessages.PROVIDE_VALID_MOBILE_NUMBER;
        } else {
            errors.first_name = '';
            errors.last_name = '';
            errors.phone = '';
            errors.email = '';
        }
        if (errors.first_name !== '' || errors.email !== '' || errors.phone !== '') isFormValid = false;
        else isFormValid = true;
        this.setState({ errors, isFormValid })
        return isFormValid
    }

    /**
    |--------------------------------------------------
    | fileUpload
    |--------------------------------------------------
    */

    fileUpload = async (event) => {
        let reader = new FileReader()
        let file = event.target.files[0]
        reader.onloadend = () => {
            this.setState({
                file: file,
                src: reader.result,
                photo_url: reader.result,
                fileVisible: true
            })
        }
        reader.readAsDataURL(file)
    }

    /**
    |--------------------------------------------------
    | handleChange
    |--------------------------------------------------
    */

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
        if (event.target.value) {
            this.setState({
                errors: Object.assign(this.state.errors, { [event.target.name]: '' })
            })
        } else {
            this.setState({
                errors: Object.assign(this.state.errors, { [event.target.name]: errorMessages.REQUIRED })
            })
        }
    }

    /**
    |--------------------------------------------------
    | deleteUser
    |--------------------------------------------------
    */

    async deleteUser(uid, cid, status) {

        swal({
            title: "Are you sure want to delete ?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async willDelete => {
                if (willDelete) {
                    var user_id = uid;
                    var company_id = cid;
                    if (status === 'active') {
                        var reactives = 'true';
                    } else {
                        var reactiven = 'false';
                    }
                    var body = { user_id: user_id, company_id: company_id, reactive: reactiven || reactives }
                    const response = await this.props.callApi('/removeEmployee', body, 'post', null, true);
                    if (response.data.code === 200) {
                        common.showSuccessMessage(response.data.message)
                        let employeeData = this.props.employeeData
                        let selectedIndex = employeeData.findIndex(x => x.user_id == uid);
                        employeeData.splice(selectedIndex, 1);
                        this.props.setEmployeeDetails([...employeeData]);
                        console.log('selectedIndex-->', selectedIndex);
                        employeeData[selectedIndex] || employeeData[0] && this.setParentStatus(employeeData[selectedIndex] || employeeData[0])
                    }
                }
            });
    }

    /**
    |--------------------------------------------------
    | Phone Number Dial Codes
    |--------------------------------------------------
    */

    handleOnChange = (value, data, event, formattedValu) => {
        let dialnum = data.dialCode;
        let mobilenum = value.slice(data.dialCode.length);
        this.setState({
            dialcode: dialnum,
            phone: mobilenum,
            rawPhone: mobilenum
        })
    }

    /**
    |--------------------------------------------------
    | Image Crop
    |--------------------------------------------------
    */

    onImageLoaded = image => {
        this.imageRef = image;
    };

    /**
    |--------------------------------------------------
    | onCropComplete
    |--------------------------------------------------
    */

    onCropComplete = (crop) => {
        this.makeClientCrop(crop);
    };

    /**
    |--------------------------------------------------
    | makeClientCrop
    |--------------------------------------------------
    */

    async makeClientCrop(crop) {
        if (this.imageRef && crop && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                this.state.profilePicName
            );
            this.setState({ croppedImageUrl });
        }
    }

    /**
    |--------------------------------------------------
    | onCropChange
    |--------------------------------------------------
    */

    onCropChange = (crop, percentCrop) => {
        this.setState({ crop });
    };

    /**
    |--------------------------------------------------
    | getCroppedImg
    |--------------------------------------------------
    */

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    common.showErrorMessage('Canvas is empty');
                    return;
                }
                this.setState({ Imgblob: blob }, () => { console.log("###", this.state.Imgblob) })
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
            }, 'image/jpeg');
        });
    }

    /**
    |--------------------------------------------------
    | openAddContactModal
    |--------------------------------------------------
    */

    openAddContactModal = () => {
        this.setState({
            isVisibleAddContact: true,
            editEmployee: false,
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            rawPhone: '',
            designation: '',
            errors: {
                message: ''
            },
            photo_url: '',
            dialcode: '',
            src: '',
            crop: {
                unit: '%',
                width: 100,
                height: 50,
                aspect: 16 / 4,
            },
            croppedImageUrl: undefined
        })
    }

    /**
    |--------------------------------------------------
    | fileChangedHandlerImg
    |--------------------------------------------------
    */

    fileChangedHandlerImg(event) {
        let reader = new FileReader()
        let file = event.target.files[0]
        let filename = event.target.files[0].name
        reader.onloadend = () => {
            this.setState({
                file: file,
                src: reader.result,
                filename: filename,
                imagePreviewUrl: reader.result,
                fileVisible: true
            })
        }
        reader.readAsDataURL(file)
    }

    /**
    |--------------------------------------------------
    | render
    |--------------------------------------------------
    */

    render() {
        let role = this.props.userData.role ? this.props.userData.role : '';
        const { categoryData, userData } = this.props
        const { viewEmployee, editEmployee, employee, first_name, last_name,
            email, phone, designation, errors, photo_url, dialcode, isAPICall } = this.state;
        let imagePreview = null;
        if (photo_url) {
            imagePreview = (<img src={photo_url} alt="Icon" />);
        } else {
            imagePreview = (<img src="images/noimage.jpeg" alt="Icon" />);
        }

        return (
            <div className="main-page-wrapper contacts-page">
                <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDelay={500}>
                    <MobileToggle {...this.props} />
                    <Leftbar onRef={ref => this.leftBarRef = ref} {...this.props} getChildEvent={this.setParentStatus} openAddContactModal={this.openAddContactModal} selectedEmployee={employee} />
                    <SidebarAnnouncement {...this.props} />
                    <div className="content-area-wrapper">
                        {employee ? <div className="content-area-inner">
                            <div className="contacts-page-inner-wrapper">
                                <div className="employee-details">
                                    <div className="company-logo-block mt-0">
                                        <span className="company-logo">
                                            {
                                                (employee.image === '') ? <img src="images/noimage.jpeg" alt="" /> :
                                                    <img src={employee.image} alt="images/noimage.jpeg" />
                                            }
                                            {/* <img src={employee.image } alt="images/may-tucker.jpg" /> */}
                                        </span>
                                        <div className="employee-name-designation">
                                            <h6>{employee.first_name} {employee.last_name}</h6>
                                            <span className="text-light text-capitalize">{employee.designation}</span>
                                        </div>
                                    </div>
                                    <div className="employee-mail-number">
                                        <p className="text-light mb-1">{employee.email}</p>
                                        <a href={`https://web.whatsapp.com/send?phone='${employee.dialcode + "" + employee.phone}'&text=`} target="_blank" rel="noopener noreferrer">
                                            <p className="text-light"> {employee.dialcode} {employee.phone}</p>
                                        </a>
                                    </div>

                                    <div className="employee-options">
                                        <ul>
                                            {/* <li>
                                                    <Link to="#">
                                                        <img src="images/message-icon.svg" alt=""/>
                                                        Send  Message
                                                    </Link>
                                                </li> */}
                                            <li>
                                                <a href={"mailto:" + employee.email} target="_blank" rel="noopener noreferrer">
                                                    <img src="images/email-icon.svg" alt="" />
                                                        Send Mail
                                                    </a>
                                            </li>
                                            {/* <li>
                                                    <Link to="#">
                                                        <img src="images/add-user.svg" alt=""/>
                                                        Add to Contacts
                                                    </Link>
                                                </li> */}
                                            {((role === appConstant.ROLE.ADMIN || role === appConstant.ROLE.COMPANY_ADMIN) && (employee.role !== appConstant.ROLE.COMPANY_ADMIN && !(employee.role == appConstant.ROLE.ADMIN && role === appConstant.ROLE.ADMIN))) && <li>
                                                <Link onClick={() => this.setState({ isPermissionModalVisible: true })}>
                                                    <img src="images/edit-user.svg" alt="" />
                                                    Add/Edit Admin
                                                </Link>
                                            </li>}
                                        </ul>
                                    </div>
                                    {
                                        ((role === appConstant.ROLE.ADMIN || role === appConstant.ROLE.COMPANY_ADMIN) || userData.user_id == employee.user_id) &&
                                        <div className="pt-4 pb-3">
                                            {((employee.user_id === userData.user_id) || (!(employee.role === appConstant.ROLE.ADMIN && role === appConstant.ROLE.ADMIN) && !(employee.role === appConstant.ROLE.COMPANY_ADMIN && role === appConstant.ROLE.ADMIN)))

                                                && <Button onClick={this.editEmployeeBtn}>edit</Button>}
                                            {((role === appConstant.ROLE.ADMIN || role === appConstant.ROLE.COMPANY_ADMIN) && (employee.role !== appConstant.ROLE.COMPANY_ADMIN && !(employee.role === appConstant.ROLE.ADMIN && role === appConstant.ROLE.ADMIN))) && <Button variant="outline-primary" className="ml-3" onClick={() => this.deleteUser(employee.user_id, employee.company_id, employee.status)}>Delete</Button>}
                                        </div>
                                    }
                                </div>

                                <div className="qr-code-block text-center mb-4">
                                    <div className="qr-code-wrapper mx-auto">
                                        <div className="qr-img-wrapper">
                                            {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                                                <img src="images/qr-code-img.svg" alt="" title="" />
                                            </a> */}
                                            <QRCode value={this.state.qrCodeLink} level="H" size={200} />
                                        </div>
                                        <p>Scan above code from phone to add in your mobile contact list.</p>
                                    </div>
                                    {/* <Link to="#" className="share-qr-code">
                                        <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <desc>Share as Contact</desc>
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g transform="translate(-3.000000, -1.000000)" fill="#4D59EE">
                                                    <path d="M20,11 C20.5128358,11 20.9355072,11.3860402 20.9932723,11.8833789 L21,12 L21,20 C21,21.5976809 19.75108,22.9036609 18.1762728,22.9949073 L18,23 L6,23 C4.40231912,23 3.09633912,21.75108 3.00509269,20.1762728 L3,20 L3,12 C3,11.4477153 3.44771525,11 4,11 C4.51283584,11 4.93550716,11.3860402 4.99327227,11.8833789 L5,12 L5,20 C5,20.5128358 5.38604019,20.9355072 5.88337887,20.9932723 L6,21 L18,21 C18.5128358,21 18.9355072,20.6139598 18.9932723,20.1166211 L19,20 L19,12 C19,11.4477153 19.4477153,11 20,11 Z M12,1 L12.0193545,1.00018615 C12.042681,1.00063489 12.0659949,1.00189498 12.0892501,1.00396641 L12,1 C12.0506203,1 12.1003621,1.00376119 12.1489612,1.01101934 C12.165949,1.01362808 12.1833753,1.01670217 12.2007258,1.02024007 C12.2227461,1.0246398 12.2444365,1.02983363 12.2658396,1.03572097 C12.2814633,1.04009773 12.2968513,1.04472872 12.3121425,1.04973809 C12.3317977,1.05612249 12.3515792,1.06331574 12.3710585,1.07110396 C12.3887956,1.07819642 12.4060985,1.08567905 12.4232215,1.09367336 C12.4438914,1.10337664 12.4642939,1.11379392 12.484277,1.12487577 C12.4963944,1.13149883 12.5086131,1.13860692 12.5207088,1.14599545 C12.546275,1.1617187 12.5711307,1.17849009 12.5951593,1.19631351 C12.6012086,1.20071786 12.6070733,1.20517454 12.6128994,1.20970461 C12.6196628,1.21507113 12.6225624,1.2173721 12.625449,1.21968877 L12.7071068,1.29289322 L16.7071068,5.29289322 C17.0976311,5.68341751 17.0976311,6.31658249 16.7071068,6.70710678 C16.3466228,7.06759074 15.7793918,7.09532028 15.3871006,6.79029539 L15.2928932,6.70710678 L13,4.414 L13,15 C13,15.5522847 12.5522847,16 12,16 C11.4871642,16 11.0644928,15.6139598 11.0067277,15.1166211 L11,15 L11,4.414 L8.70710678,6.70710678 C8.34662282,7.06759074 7.77939176,7.09532028 7.38710056,6.79029539 L7.29289322,6.70710678 C6.93240926,6.34662282 6.90467972,5.77939176 7.20970461,5.38710056 L7.29289322,5.29289322 L11.2928932,1.29289322 L11.374551,1.21968877 C11.3774376,1.2173721 11.3803372,1.21507113 11.3832499,1.21278596 L11.2928932,1.29289322 C11.3282873,1.25749917 11.3656744,1.22531295 11.4046934,1.19633458 C11.4288693,1.17849009 11.453725,1.1617187 11.4793398,1.14606743 C11.4913869,1.13860692 11.5036056,1.13149883 11.5159379,1.12467117 C11.5357061,1.11379392 11.5561086,1.10337664 11.5769009,1.09365378 C11.5939015,1.08567905 11.6112044,1.07819642 11.628664,1.07122549 C11.6484208,1.06331574 11.6682023,1.05612249 11.6882636,1.04954668 C11.7031487,1.04472872 11.7185367,1.04009773 11.734007,1.03584514 C11.7555635,1.02983363 11.7772539,1.0246398 11.7992059,1.02016515 C11.8166247,1.01670217 11.834051,1.01362808 11.8515331,1.0110178 C11.8705042,1.00811223 11.890153,1.00576612 11.909968,1.00399798 C11.9343349,1.0018656 11.9579802,1.00059932 11.9816379,1.00016755 C11.9872016,1.00006024 11.9935938,1 12,1 Z"></path>
                                                </g>
                                            </g>
                                        </svg>
                                            Share as contact
                                        </Link> */}
                                </div>
                            </div>
                        </div>
                            :
                            <div className={'loader-block'}>
                                <Spinner />
                            </div>}
                    </div>

                    <Modal className="common-modal small" centered show={this.state.isVisibleAddContact} onHide={() => this.setState({ isVisibleAddContact: false })}>
                        <button type="button" className="close fixed-close-btn" onClick={() => this.setState({ isVisibleAddContact: false })}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <Modal.Body className="">
                            <div className="content-area-inner">

                                <h6>{editEmployee ? "Edit Profile" : "Add New Employee"}</h6>

                                <div className="add-employee-block api mt-4">
                                </div>


                                <div className="add-employee-block api mt-4">
                                    <form onSubmit={editEmployee ? this.editEmployeProfile : this.AddNewEmploye}>
                                        <div className="row">
                                            <div className="col-12">
                                                {editEmployee ?
                                                    <div className="company-logo-block">

                                                        <input className="file-input company-logo-changer input-file" title="&nbsp;" type="file" name="profile_photo" accept="image/*" id="file" onChange={this.fileUpload.bind(this)} />
                                                        {this.state.src && <div className={'crop-profile-image'}>
                                                            <ReactCrop
                                                                src={this.state.src}
                                                                crop={this.state.crop}
                                                                ruleOfThirds
                                                                onImageLoaded={this.onImageLoaded}
                                                                onComplete={this.onCropComplete}
                                                                onChange={this.onCropChange}
                                                                className="mx-3"
                                                            />
                                                        </div>}
                                                        <span className="">
                                                            {(this.state.croppedImageUrl) ?
                                                                <img alt="Crop" src={this.state.croppedImageUrl} />
                                                                : <span className="company-logo mr-0"> {imagePreview} </span>
                                                            }
                                                        </span>
                                                    </div>
                                                    :
                                                    <div className="company-logo-block">

                                                        <input type="file" className="file-input company-logo-changer input-file" title="&nbsp;" name="profile_photo" accept="image/*" id="file" onChange={this.fileChangedHandlerImg.bind(this)} />
                                                        <ReactCrop
                                                            src={this.state.src}
                                                            crop={this.state.crop}
                                                            ruleOfThirds
                                                            onImageLoaded={this.onImageLoaded}
                                                            onComplete={this.onCropComplete}
                                                            onChange={this.onCropChange}
                                                            className="mx-3"
                                                        />

                                                        <span className="">
                                                            {(this.state.croppedImageUrl) ?
                                                                <span className="company-logo mr-0">
                                                                    <img alt="Crop" src={this.state.croppedImageUrl} />
                                                                </span> :
                                                                <span className="company-logo">
                                                                    <img src="images/noimage.jpeg" alt="" />
                                                                </span>
                                                            }
                                                        </span>
                                                    </div>}
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">

                                                    <input
                                                        className='form-control'
                                                        type='text'
                                                        name='first_name'
                                                        placeholder='First Name *'
                                                        value={first_name}
                                                        onChange={this.handleChange}

                                                    />
                                                    <span className="error-msg"> {errors.first_name} </span>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    <input
                                                        className='form-control'
                                                        type='text'
                                                        name='last_name'
                                                        placeholder='Last Name'
                                                        value={last_name}
                                                        onChange={this.handleChange}
                                                    />
                                                    <span className="error-msg"> {errors.last_name} </span>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    <input
                                                        type="text"
                                                        id="designation"
                                                        name="designation"
                                                        className="form-control"
                                                        placeholder="Designation"
                                                        value={designation}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Email *"
                                                        value={email}
                                                        onChange={this.handleChange}

                                                    />
                                                    <span className="error-msg"> {errors.email} </span>

                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-4">
                                                    <div className="input-group-prepend">

                                                    </div>
                                                    <PhoneInput
                                                        className="form-control"
                                                        name="phone"
                                                        country={'us'}
                                                        value={dialcode + '' + phone}
                                                        onChange={this.handleOnChange}
                                                    />
                                                    <span className='error-msg'>{errors.phone}</span>

                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <hr className="mt-1 mb-4" />
                                            </div>

                                            <div className="col-12 text-right pb-3">
                                                <Button variant="outline-primary" onClick={() => this.setState({ isVisibleAddContact: false })}>Cancel</Button>
                                                <Button type='submit' className="ml-3" disabled={isAPICall} onClick={editEmployee ? this.editEmployeProfile : this.AddNewEmploye}>{isAPICall ? "Loading..." : editEmployee ? "Update Profile" : "Save"}</Button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </Modal.Body>
                    </Modal>

                    {employee && employee.category && <PermissionModal show={this.state.isPermissionModalVisible} onHidePress={() => this.setState({ isPermissionModalVisible: false })} selectedUser={employee} onPressUpdate={() => this.leftBarRef.getEmployeeDetails(employee.user_id)} />}
                </Animated>
            </div >
        );
    }
}
const mapStateToProps = (state) => {
    return {
        userData: state.getUserData,
        employeeData: state.employeeList,
        categoryData: state.categoryList,
    }
}
export default withRouter(connect(mapStateToProps, { callApi, setEmployeeDetails })(Contacts))
